import React from "react";
import { motion } from "framer-motion";
import { fadeUp, staggerChildren, viewportOnce } from "../../utils/motionPresets";

const SectionHead = ({ index, eyebrow, title, lede }) => (
  <motion.header
    className="section-head"
    variants={staggerChildren}
    initial="hidden"
    whileInView="visible"
    viewport={viewportOnce}
  >
    <div>
      <motion.span className="eyebrow" variants={fadeUp}>
        <span className="eyebrow__index">{index}</span>
        {eyebrow}
      </motion.span>
      <motion.h2 className="section-title" variants={fadeUp}>
        {title}
      </motion.h2>
    </div>
    {lede && (
      <motion.p className="section-lede" variants={fadeUp}>
        {lede}
      </motion.p>
    )}
  </motion.header>
);

export default SectionHead;
